import Vue from 'vue';
// https://github.com/kazupon/vue-i18n
import VueI18n from 'vue-i18n';

// importando traduções
import pt from '@/i18n/pt.json';
import es from '@/i18n/es.json';
import en from '@/i18n/en.json';

// Formato de dedas com diferentes formatações
let dates = {
    short: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    },
    shortText: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    },
    average: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
    },
    averageText: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
    },
    long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
    },
};

// Formatação de data por idioma
const datetimeFormats = {
    pt: dates,
    es: dates,
    en: dates,
};

// Formatação de moeda por idioma
const numberFormats = {
    pt: {
        currency: {
            style: 'currency',
            currency: 'BRL',
        },
        decimal: {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
    es: {
        currency: {
            style: 'currency',
            currency: 'EUR',
        },
        decimal: {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
    en: {
        currency: {
            style: 'currency',
            currency: 'USD',
        },
        decimal: {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};

Vue.use(VueI18n);

// Exportando e e pegando linguagem padrão
export default new VueI18n({
    // legacy: true,
    datetimeFormats,
    numberFormats,
    locale: process.env.VITE_VUE_APP_I18N_LOCALE || 'pt',
    fallbackLocale: process.env.VITE_VUE_APP_I18N_FALLBACK_LOCALE || 'pt', 
    messages: {
        pt: pt,
        es: es,
        en: en,
    },
});

